// src/routes/UCLAbsnLayout.tsx
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "src/contexts/AuthContext";
import UnauthorizedPage from "src/pages/UnauthorizedPage";

const UCLAbsnLayout: React.FC = () => {
    const { userDoc } = useAuth();
    const location = useLocation();

    if (
        userDoc?.studentFrom !== "ucla-bsn" &&
        location.pathname.split("/")[2] !== "login"
    ) {
        return <UnauthorizedPage />;
    }

    return <Outlet />;
};

export default UCLAbsnLayout;
